import React from "react";
import "./styles.css";
import styled, { css } from "styled-components";
import HandPhone from "./HandPhone.png";
import { Corona, Guard, Check, AppIcon, AnimatedBeep } from "./Icons";

const Arrows = styled(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8.828"
    height="14.828"
    viewBox="0 0 8.828 14.828"
  >
    <line
      id="Line_1"
      data-name="Line 1"
      x2="6"
      y2="6"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke="#c4c4c6"
      stroke-linecap="round"
      stroke-width="2"
    />
    <line
      id="Line_2"
      data-name="Line 2"
      y1="6"
      x2="6"
      transform="translate(1.414 7.414)"
      fill="none"
      stroke="#c4c4c6"
      stroke-linecap="round"
      stroke-width="2"
    />
  </svg>
))``;

const Card = styled.div`
  margin: 12px;
  padding: 20px;

  background: white;
  box-shadow: 0px 0px 13px #00000012;
  border-radius: 11px;
  ${({ green }) =>
    green &&
    css`
      background-color: #78a22f;
      color: white;
    `}
`;

const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #7ebed5;
`;

const Hor = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
${({ grow }) =>
  grow &&
  css`
    flex-grow: 1;
  `}
color: #17191a;
  ${({ white }) =>
    white &&
    css`
      color: white;
    `}
    ${({ grey }) =>
      grey &&
      css`
        color: #a0a1a1;
      `}
    
  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}
  ${({ grow }) => grow && css``}
  ${({ padded }) =>
    padded &&
    css`
      padding: 0 16px;
    `}
    ${({ padtop }) =>
      padtop &&
      css`
        padding-top: 16px;
        padding-bottom: 16px;
      `}
    ${({ title }) =>
      title &&
      css`
        font-size: 24px;
      `}
`;

const PhoneImage = styled.img`
  height: 100px;
  transform: translateX(20px);
`;

const Button = styled.button`
  background: #0f6fc7;
  width: calc(100% - 40px);
  padding: 16px;
  font-size: 18px;
  margin: 20px;
  margin-bottom: 0;
  color: white;
  font-weight: bold;
  -webkit-appearance: none;
  border: none;
  border-radius: 7px;
`;

const ActionCard = styled.div`
  background: white;
  padding: 16px 16px;
  display: flex;
  & > div:first-child {
    flex-grow: 1;
  }
  & > div:nth-child(2) {
    width: 8.828px;
  }
  border: 1px solid #f9fafa;
`;

const Spacer = styled.div`
  height: 40px;
  ${({ small }) =>
    small &&
    css`
      height: 20px;
    `}
`;

const GreenSpacer = styled.div`
  height: 0;

  width: calc(100% - 32px);
  border: 1px solid #87ac46;
  margin-left: 32px;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const TitleBar = styled.div`
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  padding: 8px 16px;
  background: #fdfefd;
`;

const InfoBox = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #007dc5;
  position: relative;
  & > span {
    font-size: 18px;
    font-weight: bold;
    font-family: monospace;
    color: #007dc5;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    position: absolute;
  }
`;

export default function App() {
  return (
    <>
      <TitleBar>
        <Hor>
          <AppIcon />
          <Text bold title grow padded>
            #OstaniZdrav
          </Text>
          <InfoBox>
            <span>i</span>
          </InfoBox>
        </Hor>
      </TitleBar>
      <Card>
        <Hor>
          <AnimatedBeep />
          <Text grow padded bold>
            Exposure logging active
          </Text>
          <Arrows />
        </Hor>
      </Card>
      <Card green>
        <Hor>
          <Text bold title white grow>
            Low risk
          </Text>
        </Hor>
        <Spacer small />
        <Hor>
          <Corona />
          <Text white padded>
            No exposure up to now
          </Text>
        </Hor>
        <GreenSpacer />
        <Hor>
          <Check />
          <Text white padded>
            Exposure logging permanently active
          </Text>
        </Hor>
        <GreenSpacer />
        <Hor>
          <Guard />
          <Text white padded>
            Updated: Yesterday, 22:22
          </Text>
        </Hor>
      </Card>
      <Card>
        <Hor>
          <Text grow bold>
            Have you been tested?
          </Text>
          <Arrows />
        </Hor>
        <Hor>
          <Text padtop grey grow>
            Help break chain of infection by notifying others.
          </Text>
          <PhoneImage src={HandPhone} />
        </Hor>
        <Button>Input the test result</Button>
      </Card>
      <Spacer />
      <ActionCard>
        <div>
          <Text bold>Share the #OstaniZdrav App</Text>
          <Text padtop grey grow>
            The more people who use the app, the faster we can break the chain
            of infection. Please invite your family and friends to download the
            app.
          </Text>
        </div>
        <div>
          <Arrows />
        </div>
      </ActionCard>
      <ActionCard>
        <div>
          <Text bold>More about #OstaniZdrav App</Text>
          <Text padtop grey grow>
            More about the #OstaniZdrav App. You will be forwarded to an
            external website
          </Text>
        </div>
        <div>
          <Arrows />
        </div>
      </ActionCard>
      <Spacer />
      <ActionCard>
        <div>
          <Text bold>App information</Text>
        </div>
        <div>
          <Arrows />
        </div>
      </ActionCard>
      <ActionCard>
        <div>
          <Text bold>Settings</Text>
        </div>
        <div>
          <Arrows />
        </div>
      </ActionCard>
    </>
  );
}
